import { render, staticRenderFns } from "./IAR.vue?vue&type=template&id=02aa2d02&scoped=true&"
import script from "./IAR.vue?vue&type=script&lang=js&"
export * from "./IAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa2d02",
  null
  
)

export default component.exports